import * as GeoSearch from 'leaflet-geosearch';
import GeometryUtil from "leaflet-geometryutil";
import './leaflat/markercluster/leaflet.markercluster';

export let map;
export let markers = new L.MarkerClusterGroup();
let markersList = [];
let circlesList = [];
let centerLat, centerLng = '';
let routingControl;
let polyControl;
const now = new Date();
let markersCoords = [];
let coords = {lat: "", lon: ""};
let closestCoords = {lat: "", lon: ""};
let backData = {};
let currentPosition = {};
let pLineGroup = L.layerGroup();
let polylines = [];
let currentMarker = null;

//// ------------------------------------------
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['leaflet'], factory);
    } else if (typeof modules === 'object' && module.exports) {
        // define a Common JS module that relies on 'leaflet'
        module.exports = factory(require('leaflet'));
    } else {
        // Assume Leaflet is loaded into global object L already
        factory(L);
    }
}(this, function (L) {
    'use strict';

    L.TileLayer.Provider = L.TileLayer.extend({
        initialize: function (arg, options) {
            var providers = L.TileLayer.Provider.providers;

            var parts = arg.split('.');

            var providerName = parts[0];
            var variantName = parts[1];

            if (!providers[providerName]) {
                throw 'No such provider (' + providerName + ')';
            }

            var provider = {
                url: providers[providerName].url,
                options: providers[providerName].options
            };

            // overwrite values in provider from variant.
            if (variantName && 'variants' in providers[providerName]) {
                if (!(variantName in providers[providerName].variants)) {
                    throw 'No such variant of ' + providerName + ' (' + variantName + ')';
                }
                var variant = providers[providerName].variants[variantName];
                var variantOptions;
                if (typeof variant === 'string') {
                    variantOptions = {
                        variant: variant
                    };
                } else {
                    variantOptions = variant.options;
                }
                provider = {
                    url: variant.url || provider.url,
                    options: L.Util.extend({}, provider.options, variantOptions)
                };
            }

            // replace attribution placeholders with their values from toplevel provider attribution,
            // recursively
            var attributionReplacer = function (attr) {
                if (attr.indexOf('{attribution.') === -1) {
                    return attr;
                }
                return attr.replace(/\{attribution.(\w*)\}/g,
                    function (match, attributionName) {
                        return attributionReplacer(providers[attributionName].options.attribution);
                    }
                );
            };
            provider.options.attribution = attributionReplacer(provider.options.attribution);

            // Compute final options combining provider options with any user overrides
            var layerOpts = L.Util.extend({}, provider.options, options);
            L.TileLayer.prototype.initialize.call(this, provider.url, layerOpts);
        }
    });

    /**
     * Definition of providers.
     * see http://leafletjs.com/reference.html#tilelayer for options in the options map.
     */

    L.TileLayer.Provider.providers = {
        OpenStreetMap: {
            url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
            options: {
                maxZoom: 19,
                attribution:
                    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            },
            variants: {
                Mapnik: {},
                DE: {
                    url: 'https://tile.openstreetmap.de/{z}/{x}/{y}.png',
                    options: {
                        maxZoom: 18
                    }
                },
                CH: {
                    url: 'https://tile.osm.ch/switzerland/{z}/{x}/{y}.png',
                    options: {
                        maxZoom: 18,
                        bounds: [[45, 5], [48, 11]]
                    }
                },
                France: {
                    url: 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
                    options: {
                        maxZoom: 20,
                        attribution: '&copy; OpenStreetMap France | {attribution.OpenStreetMap}'
                    }
                },
                HOT: {
                    url: 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
                    options: {
                        attribution:
                            '{attribution.OpenStreetMap}, ' +
                            'Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> ' +
                            'hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>'
                    }
                },
                BZH: {
                    url: 'https://tile.openstreetmap.bzh/br/{z}/{x}/{y}.png',
                    options: {
                        attribution: '{attribution.OpenStreetMap}, Tiles courtesy of <a href="http://www.openstreetmap.bzh/" target="_blank">Breton OpenStreetMap Team</a>',
                        bounds: [[46.2, -5.5], [50, 0.7]]
                    }
                }
            }
        },
        MapTilesAPI: {
            url: 'https://maptiles.p.rapidapi.com/{variant}/{z}/{x}/{y}.png?rapidapi-key={apikey}',
            options: {
                attribution:
                    '&copy; <a href="http://www.maptilesapi.com/">MapTiles API</a>, {attribution.OpenStreetMap}',
                variant: 'en/map/v1',
                // Get your own MapTiles API access token here : https://www.maptilesapi.com/
                // NB : this is a demonstration key that comes with no guarantee and not to be used in production
                apikey: '<insert your api key here>',
                maxZoom: 19
            },
            variants: {
                OSMEnglish: {
                    options: {
                        variant: 'en/map/v1'
                    }
                },
                OSMFrancais: {
                    options: {
                        variant: 'fr/map/v1'
                    }
                },
                OSMEspagnol: {
                    options: {
                        variant: 'es/map/v1'
                    }
                }
            }
        },
        OpenSeaMap: {
            url: 'https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png',
            options: {
                attribution: 'Map data: &copy; <a href="http://www.openseamap.org">OpenSeaMap</a> contributors'
            }
        },
        OPNVKarte: {
            url: 'https://tileserver.memomaps.de/tilegen/{z}/{x}/{y}.png',
            options: {
                maxZoom: 18,
                attribution: 'Map <a href="https://memomaps.de/">memomaps.de</a> <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, map data {attribution.OpenStreetMap}'
            }
        },
        OpenTopoMap: {
            url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
            options: {
                maxZoom: 17,
                attribution: 'Map data: {attribution.OpenStreetMap}, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            }
        },
        OpenRailwayMap: {
            url: 'https://{s}.tiles.openrailwaymap.org/standard/{z}/{x}/{y}.png',
            options: {
                maxZoom: 19,
                attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="https://www.OpenRailwayMap.org">OpenRailwayMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            }
        },
        OpenFireMap: {
            url: 'http://openfiremap.org/hytiles/{z}/{x}/{y}.png',
            options: {
                maxZoom: 19,
                attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="http://www.openfiremap.org">OpenFireMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            }
        },
        SafeCast: {
            url: 'https://s3.amazonaws.com/te512.safecast.org/{z}/{x}/{y}.png',
            options: {
                maxZoom: 16,
                attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="https://blog.safecast.org/about/">SafeCast</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            }
        },
        Stadia: {
            url: 'https://tiles.stadiamaps.com/tiles/{variant}/{z}/{x}/{y}{r}.{ext}',
            options: {
                minZoom: 0,
                maxZoom: 20,
                attribution:
                    '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
                    '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
                    '{attribution.OpenStreetMap}',
                variant: 'alidade_smooth',
                ext: 'png'
            },
            variants: {
                AlidadeSmooth: 'alidade_smooth',
                AlidadeSmoothDark: 'alidade_smooth_dark',
                OSMBright: 'osm_bright',
                Outdoors: 'outdoors',
                StamenToner: {
                    options: {
                        attribution:
                            '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
                            '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
                            '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
                            '{attribution.OpenStreetMap}',
                        variant: 'stamen_toner'
                    }
                },
                StamenTonerBackground: {
                    options: {
                        attribution:
                            '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
                            '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
                            '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
                            '{attribution.OpenStreetMap}',
                        variant: 'stamen_toner_background'
                    }
                },
                StamenTonerLines: {
                    options: {
                        attribution:
                            '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
                            '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
                            '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
                            '{attribution.OpenStreetMap}',
                        variant: 'stamen_toner_lines'
                    }
                },
                StamenTonerLabels: {
                    options: {
                        attribution:
                            '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
                            '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
                            '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
                            '{attribution.OpenStreetMap}',
                        variant: 'stamen_toner_labels'
                    }
                },
                StamenTonerLite: {
                    options: {
                        attribution:
                            '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
                            '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
                            '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
                            '{attribution.OpenStreetMap}',
                        variant: 'stamen_toner_lite'
                    }
                },
                StamenWatercolor: {
                    url: 'https://tiles.stadiamaps.com/tiles/{variant}/{z}/{x}/{y}.{ext}',
                    options: {
                        attribution:
                            '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
                            '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
                            '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
                            '{attribution.OpenStreetMap}',
                        variant: 'stamen_watercolor',
                        ext: 'jpg',
                        minZoom: 1,
                        maxZoom: 16
                    }
                },
                StamenTerrain: {
                    options: {
                        attribution:
                            '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
                            '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
                            '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
                            '{attribution.OpenStreetMap}',
                        variant: 'stamen_terrain',
                        minZoom: 0,
                        maxZoom: 18
                    }
                },
                StamenTerrainBackground: {
                    options: {
                        attribution:
                            '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
                            '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
                            '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
                            '{attribution.OpenStreetMap}',
                        variant: 'stamen_terrain_background',
                        minZoom: 0,
                        maxZoom: 18
                    }
                },
                StamenTerrainLabels: {
                    options: {
                        attribution:
                            '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
                            '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
                            '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
                            '{attribution.OpenStreetMap}',
                        variant: 'stamen_terrain_labels',
                        minZoom: 0,
                        maxZoom: 18
                    }
                },
                StamenTerrainLines: {
                    options: {
                        attribution:
                            '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> ' +
                            '&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> ' +
                            '&copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> ' +
                            '{attribution.OpenStreetMap}',
                        variant: 'stamen_terrain_lines',
                        minZoom: 0,
                        maxZoom: 18
                    }
                }
            }
        },
        Thunderforest: {
            url: 'https://{s}.tile.thunderforest.com/{variant}/{z}/{x}/{y}.png?apikey={apikey}',
            options: {
                attribution:
                    '&copy; <a href="http://www.thunderforest.com/">Thunderforest</a>, {attribution.OpenStreetMap}',
                variant: 'cycle',
                apikey: '<insert your api key here>',
                maxZoom: 22
            },
            variants: {
                OpenCycleMap: 'cycle',
                Transport: {
                    options: {
                        variant: 'transport'
                    }
                },
                TransportDark: {
                    options: {
                        variant: 'transport-dark'
                    }
                },
                SpinalMap: {
                    options: {
                        variant: 'spinal-map'
                    }
                },
                Landscape: 'landscape',
                Outdoors: 'outdoors',
                Pioneer: 'pioneer',
                MobileAtlas: 'mobile-atlas',
                Neighbourhood: 'neighbourhood'
            }
        },
        CyclOSM: {
            url: 'https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
            options: {
                maxZoom: 20,
                attribution: '<a href="https://github.com/cyclosm/cyclosm-cartocss-style/releases" title="CyclOSM - Open Bicycle render">CyclOSM</a> | Map data: {attribution.OpenStreetMap}'
            }
        },
        Jawg: {
            url: 'https://{s}.tile.jawg.io/{variant}/{z}/{x}/{y}{r}.png?access-token={accessToken}',
            options: {
                attribution:
                    '<a href="http://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank">&copy; <b>Jawg</b>Maps</a> ' +
                    '{attribution.OpenStreetMap}',
                minZoom: 0,
                maxZoom: 22,
                subdomains: 'abcd',
                variant: 'jawg-terrain',
                // Get your own Jawg access token here : https://www.jawg.io/lab/
                // NB : this is a demonstration key that comes with no guarantee
                accessToken: '<insert your access token here>',
            },
            variants: {
                Streets: 'jawg-streets',
                Terrain: 'jawg-terrain',
                Sunny: 'jawg-sunny',
                Dark: 'jawg-dark',
                Light: 'jawg-light',
                Matrix: 'jawg-matrix'
            }
        },
        MapBox: {
            url: 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}{r}?access_token={accessToken}',
            options: {
                attribution:
                    '&copy; <a href="https://www.mapbox.com/about/maps/" target="_blank">Mapbox</a> ' +
                    '{attribution.OpenStreetMap} ' +
                    '<a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a>',
                tileSize: 512,
                maxZoom: 18,
                zoomOffset: -1,
                id: 'mapbox/streets-v11',
                accessToken: '<insert your access token here>',
            }
        },
        MapTiler: {
            url: 'https://api.maptiler.com/maps/{variant}/{z}/{x}/{y}{r}.{ext}?key={key}',
            options: {
                attribution:
                    '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
                variant: 'streets',
                ext: 'png',
                key: '<insert your MapTiler Cloud API key here>',
                tileSize: 512,
                zoomOffset: -1,
                minZoom: 0,
                maxZoom: 21
            },
            variants: {
                Streets: 'streets',
                Basic: 'basic',
                Bright: 'bright',
                Pastel: 'pastel',
                Positron: 'positron',
                Hybrid: {
                    options: {
                        variant: 'hybrid',
                        ext: 'jpg'
                    }
                },
                Toner: 'toner',
                Topo: 'topo',
                Voyager: 'voyager'
            }
        },
        TomTom: {
            url: 'https://{s}.api.tomtom.com/map/1/tile/{variant}/{style}/{z}/{x}/{y}.{ext}?key={apikey}',
            options: {
                variant: 'basic',
                maxZoom: 22,
                attribution:
                    '<a href="https://tomtom.com" target="_blank">&copy;  1992 - ' + new Date().getFullYear() + ' TomTom.</a> ',
                subdomains: 'abcd',
                style: 'main',
                ext: 'png',
                apikey: '<insert your API key here>',
            },
            variants: {
                Basic: 'basic',
                Hybrid: 'hybrid',
                Labels: 'labels'
            }
        },
        Esri: {
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/{variant}/MapServer/tile/{z}/{y}/{x}',
            options: {
                variant: 'World_Street_Map',
                attribution: 'Tiles &copy; Esri'
            },
            variants: {
                WorldStreetMap: {
                    options: {
                        attribution:
                            '{attribution.Esri} &mdash; ' +
                            'Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012'
                    }
                },
                DeLorme: {
                    options: {
                        variant: 'Specialty/DeLorme_World_Base_Map',
                        minZoom: 1,
                        maxZoom: 11,
                        attribution: '{attribution.Esri} &mdash; Copyright: &copy;2012 DeLorme'
                    }
                },
                WorldTopoMap: {
                    options: {
                        variant: 'World_Topo_Map',
                        attribution:
                            '{attribution.Esri} &mdash; ' +
                            'Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
                    }
                },
                WorldImagery: {
                    options: {
                        variant: 'World_Imagery',
                        attribution:
                            '{attribution.Esri} &mdash; ' +
                            'Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
                    }
                },
                WorldTerrain: {
                    options: {
                        variant: 'World_Terrain_Base',
                        maxZoom: 13,
                        attribution:
                            '{attribution.Esri} &mdash; ' +
                            'Source: USGS, Esri, TANA, DeLorme, and NPS'
                    }
                },
                WorldShadedRelief: {
                    options: {
                        variant: 'World_Shaded_Relief',
                        maxZoom: 13,
                        attribution: '{attribution.Esri} &mdash; Source: Esri'
                    }
                },
                WorldPhysical: {
                    options: {
                        variant: 'World_Physical_Map',
                        maxZoom: 8,
                        attribution: '{attribution.Esri} &mdash; Source: US National Park Service'
                    }
                },
                OceanBasemap: {
                    options: {
                        variant: 'Ocean/World_Ocean_Base',
                        maxZoom: 13,
                        attribution: '{attribution.Esri} &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri'
                    }
                },
                NatGeoWorldMap: {
                    options: {
                        variant: 'NatGeo_World_Map',
                        maxZoom: 16,
                        attribution: '{attribution.Esri} &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC'
                    }
                },
                WorldGrayCanvas: {
                    options: {
                        variant: 'Canvas/World_Light_Gray_Base',
                        maxZoom: 16,
                        attribution: '{attribution.Esri} &mdash; Esri, DeLorme, NAVTEQ'
                    }
                }
            }
        },
        OpenWeatherMap: {
            url: 'http://{s}.tile.openweathermap.org/map/{variant}/{z}/{x}/{y}.png?appid={apiKey}',
            options: {
                maxZoom: 19,
                attribution: 'Map data &copy; <a href="http://openweathermap.org">OpenWeatherMap</a>',
                apiKey: '<insert your api key here>',
                opacity: 0.5
            },
            variants: {
                Clouds: 'clouds',
                CloudsClassic: 'clouds_cls',
                Precipitation: 'precipitation',
                PrecipitationClassic: 'precipitation_cls',
                Rain: 'rain',
                RainClassic: 'rain_cls',
                Pressure: 'pressure',
                PressureContour: 'pressure_cntr',
                Wind: 'wind',
                Temperature: 'temp',
                Snow: 'snow'
            }
        },
        HERE: {
            /*
             * HERE maps, formerly Nokia maps.
             * These basemaps are free, but you need an api id and app key. Please sign up at
             * https://developer.here.com/plans
             */
            url:
                'https://{s}.{base}.maps.api.here.com/maptile/2.1/' +
                '{type}/{mapID}/{variant}/{z}/{x}/{y}/{size}/{format}?' +
                'app_id={app_id}&app_code={app_code}&lg={language}',
            options: {
                attribution:
                    'Map &copy; 1987-' + new Date().getFullYear() + ' <a href="http://developer.here.com">HERE</a>',
                subdomains: '1234',
                mapID: 'newest',
                'app_id': '<insert your app_id here>',
                'app_code': '<insert your app_code here>',
                base: 'base',
                variant: 'normal.day',
                maxZoom: 20,
                type: 'maptile',
                language: 'eng',
                format: 'png8',
                size: '256'
            },
            variants: {
                normalDay: 'normal.day',
                normalDayCustom: 'normal.day.custom',
                normalDayGrey: 'normal.day.grey',
                normalDayMobile: 'normal.day.mobile',
                normalDayGreyMobile: 'normal.day.grey.mobile',
                normalDayTransit: 'normal.day.transit',
                normalDayTransitMobile: 'normal.day.transit.mobile',
                normalDayTraffic: {
                    options: {
                        variant: 'normal.traffic.day',
                        base: 'traffic',
                        type: 'traffictile'
                    }
                },
                normalNight: 'normal.night',
                normalNightMobile: 'normal.night.mobile',
                normalNightGrey: 'normal.night.grey',
                normalNightGreyMobile: 'normal.night.grey.mobile',
                normalNightTransit: 'normal.night.transit',
                normalNightTransitMobile: 'normal.night.transit.mobile',
                reducedDay: 'reduced.day',
                reducedNight: 'reduced.night',
                basicMap: {
                    options: {
                        type: 'basetile'
                    }
                },
                mapLabels: {
                    options: {
                        type: 'labeltile',
                        format: 'png'
                    }
                },
                trafficFlow: {
                    options: {
                        base: 'traffic',
                        type: 'flowtile'
                    }
                },
                carnavDayGrey: 'carnav.day.grey',
                hybridDay: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.day'
                    }
                },
                hybridDayMobile: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.day.mobile'
                    }
                },
                hybridDayTransit: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.day.transit'
                    }
                },
                hybridDayGrey: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.grey.day'
                    }
                },
                hybridDayTraffic: {
                    options: {
                        variant: 'hybrid.traffic.day',
                        base: 'traffic',
                        type: 'traffictile'
                    }
                },
                pedestrianDay: 'pedestrian.day',
                pedestrianNight: 'pedestrian.night',
                satelliteDay: {
                    options: {
                        base: 'aerial',
                        variant: 'satellite.day'
                    }
                },
                terrainDay: {
                    options: {
                        base: 'aerial',
                        variant: 'terrain.day'
                    }
                },
                terrainDayMobile: {
                    options: {
                        base: 'aerial',
                        variant: 'terrain.day.mobile'
                    }
                }
            }
        },
        HEREv3: {
            /*
             * HERE maps API Version 3.
             * These basemaps are free, but you need an API key. Please sign up at
             * https://developer.here.com/plans
             * Version 3 deprecates the app_id and app_code access in favor of apiKey
             *
             * Supported access methods as of 2019/12/21:
             * @see https://developer.here.com/faqs#access-control-1--how-do-you-control-access-to-here-location-services
             */
            url:
                'https://{s}.{base}.maps.ls.hereapi.com/maptile/2.1/' +
                '{type}/{mapID}/{variant}/{z}/{x}/{y}/{size}/{format}?' +
                'apiKey={apiKey}&lg={language}',
            options: {
                attribution:
                    'Map &copy; 1987-' + new Date().getFullYear() + ' <a href="http://developer.here.com">HERE</a>',
                subdomains: '1234',
                mapID: 'newest',
                apiKey: '<insert your apiKey here>',
                base: 'base',
                variant: 'normal.day',
                maxZoom: 20,
                type: 'maptile',
                language: 'eng',
                format: 'png8',
                size: '256'
            },
            variants: {
                normalDay: 'normal.day',
                normalDayCustom: 'normal.day.custom',
                normalDayGrey: 'normal.day.grey',
                normalDayMobile: 'normal.day.mobile',
                normalDayGreyMobile: 'normal.day.grey.mobile',
                normalDayTransit: 'normal.day.transit',
                normalDayTransitMobile: 'normal.day.transit.mobile',
                normalNight: 'normal.night',
                normalNightMobile: 'normal.night.mobile',
                normalNightGrey: 'normal.night.grey',
                normalNightGreyMobile: 'normal.night.grey.mobile',
                normalNightTransit: 'normal.night.transit',
                normalNightTransitMobile: 'normal.night.transit.mobile',
                reducedDay: 'reduced.day',
                reducedNight: 'reduced.night',
                basicMap: {
                    options: {
                        type: 'basetile'
                    }
                },
                mapLabels: {
                    options: {
                        type: 'labeltile',
                        format: 'png'
                    }
                },
                trafficFlow: {
                    options: {
                        base: 'traffic',
                        type: 'flowtile'
                    }
                },
                carnavDayGrey: 'carnav.day.grey',
                hybridDay: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.day'
                    }
                },
                hybridDayMobile: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.day.mobile'
                    }
                },
                hybridDayTransit: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.day.transit'
                    }
                },
                hybridDayGrey: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.grey.day'
                    }
                },
                pedestrianDay: 'pedestrian.day',
                pedestrianNight: 'pedestrian.night',
                satelliteDay: {
                    options: {
                        base: 'aerial',
                        variant: 'satellite.day'
                    }
                },
                terrainDay: {
                    options: {
                        base: 'aerial',
                        variant: 'terrain.day'
                    }
                },
                terrainDayMobile: {
                    options: {
                        base: 'aerial',
                        variant: 'terrain.day.mobile'
                    }
                }
            }
        },
        FreeMapSK: {
            url: 'https://{s}.freemap.sk/T/{z}/{x}/{y}.jpeg',
            options: {
                minZoom: 8,
                maxZoom: 16,
                subdomains: 'abcd',
                bounds: [[47.204642, 15.996093], [49.830896, 22.576904]],
                attribution:
                    '{attribution.OpenStreetMap}, visualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>'
            }
        },
        MtbMap: {
            url: 'http://tile.mtbmap.cz/mtbmap_tiles/{z}/{x}/{y}.png',
            options: {
                attribution:
                    '{attribution.OpenStreetMap} &amp; USGS'
            }
        },
        CartoDB: {
            url: 'https://{s}.basemaps.cartocdn.com/{variant}/{z}/{x}/{y}{r}.png',
            options: {
                attribution: '{attribution.OpenStreetMap} &copy; <a href="https://carto.com/attributions">CARTO</a>',
                subdomains: 'abcd',
                maxZoom: 20,
                variant: 'light_all'
            },
            variants: {
                Positron: 'light_all',
                PositronNoLabels: 'light_nolabels',
                PositronOnlyLabels: 'light_only_labels',
                DarkMatter: 'dark_all',
                DarkMatterNoLabels: 'dark_nolabels',
                DarkMatterOnlyLabels: 'dark_only_labels',
                Voyager: 'rastertiles/voyager',
                VoyagerNoLabels: 'rastertiles/voyager_nolabels',
                VoyagerOnlyLabels: 'rastertiles/voyager_only_labels',
                VoyagerLabelsUnder: 'rastertiles/voyager_labels_under'
            }
        },
        HikeBike: {
            url: 'https://tiles.wmflabs.org/{variant}/{z}/{x}/{y}.png',
            options: {
                maxZoom: 19,
                attribution: '{attribution.OpenStreetMap}',
                variant: 'hikebike'
            },
            variants: {
                HikeBike: {},
                HillShading: {
                    options: {
                        maxZoom: 15,
                        variant: 'hillshading'
                    }
                }
            }
        },
        BasemapAT: {
            url: 'https://mapsneu.wien.gv.at/basemap/{variant}/{type}/google3857/{z}/{y}/{x}.{format}',
            options: {
                maxZoom: 19,
                attribution: 'Datenquelle: <a href="https://www.basemap.at">basemap.at</a>',
                type: 'normal',
                format: 'png',
                bounds: [[46.358770, 8.782379], [49.037872, 17.189532]],
                variant: 'geolandbasemap'
            },
            variants: {
                basemap: {
                    options: {
                        maxZoom: 20, // currently only in Vienna
                        variant: 'geolandbasemap'
                    }
                },
                grau: 'bmapgrau',
                overlay: 'bmapoverlay',
                terrain: {
                    options: {
                        variant: 'bmapgelaende',
                        type: 'grau',
                        format: 'jpeg'
                    }
                },
                surface: {
                    options: {
                        variant: 'bmapoberflaeche',
                        type: 'grau',
                        format: 'jpeg'
                    }
                },
                highdpi: {
                    options: {
                        variant: 'bmaphidpi',
                        format: 'jpeg'
                    }
                },
                orthofoto: {
                    options: {
                        maxZoom: 20, // currently only in Vienna
                        variant: 'bmaporthofoto30cm',
                        format: 'jpeg'
                    }
                }
            }
        },
        nlmaps: {
            url: 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0/{variant}/EPSG:3857/{z}/{x}/{y}.png',
            options: {
                minZoom: 6,
                maxZoom: 19,
                bounds: [[50.5, 3.25], [54, 7.6]],
                attribution: 'Kaartgegevens &copy; <a href="https://www.kadaster.nl">Kadaster</a>'
            },
            variants: {
                'standaard': 'standaard',
                'pastel': 'pastel',
                'grijs': 'grijs',
                'water': 'water',
                'luchtfoto': {
                    'url': 'https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/Actueel_ortho25/EPSG:3857/{z}/{x}/{y}.jpeg',
                }
            }
        },
        NASAGIBS: {
            url: 'https://map1.vis.earthdata.nasa.gov/wmts-webmerc/{variant}/default/{time}/{tilematrixset}{maxZoom}/{z}/{y}/{x}.{format}',
            options: {
                attribution:
                    'Imagery provided by services from the Global Imagery Browse Services (GIBS), operated by the NASA/GSFC/Earth Science Data and Information System ' +
                    '(<a href="https://earthdata.nasa.gov">ESDIS</a>) with funding provided by NASA/HQ.',
                bounds: [[-85.0511287776, -179.999999975], [85.0511287776, 179.999999975]],
                minZoom: 1,
                maxZoom: 9,
                format: 'jpg',
                time: '',
                tilematrixset: 'GoogleMapsCompatible_Level'
            },
            variants: {
                ModisTerraTrueColorCR: 'MODIS_Terra_CorrectedReflectance_TrueColor',
                ModisTerraBands367CR: 'MODIS_Terra_CorrectedReflectance_Bands367',
                ViirsEarthAtNight2012: {
                    options: {
                        variant: 'VIIRS_CityLights_2012',
                        maxZoom: 8
                    }
                },
                ModisTerraLSTDay: {
                    options: {
                        variant: 'MODIS_Terra_Land_Surface_Temp_Day',
                        format: 'png',
                        maxZoom: 7,
                        opacity: 0.75
                    }
                },
                ModisTerraSnowCover: {
                    options: {
                        variant: 'MODIS_Terra_NDSI_Snow_Cover',
                        format: 'png',
                        maxZoom: 8,
                        opacity: 0.75
                    }
                },
                ModisTerraAOD: {
                    options: {
                        variant: 'MODIS_Terra_Aerosol',
                        format: 'png',
                        maxZoom: 6,
                        opacity: 0.75
                    }
                },
                ModisTerraChlorophyll: {
                    options: {
                        variant: 'MODIS_Terra_Chlorophyll_A',
                        format: 'png',
                        maxZoom: 7,
                        opacity: 0.75
                    }
                }
            }
        },
        NLS: {
            // NLS maps are copyright National library of Scotland.
            // http://maps.nls.uk/projects/api/index.html
            // Please contact NLS for anything other than non-commercial low volume usage
            //
            // Map sources: Ordnance Survey 1:1m to 1:63K, 1920s-1940s
            //   z0-9  - 1:1m
            //  z10-11 - quarter inch (1:253440)
            //  z12-18 - one inch (1:63360)
            url: 'https://nls-{s}.tileserver.com/nls/{z}/{x}/{y}.jpg',
            options: {
                attribution: '<a href="http://geo.nls.uk/maps/">National Library of Scotland Historic Maps</a>',
                bounds: [[49.6, -12], [61.7, 3]],
                minZoom: 1,
                maxZoom: 18,
                subdomains: '0123',
            }
        },
        JusticeMap: {
            // Justice Map (http://www.justicemap.org/)
            // Visualize race and income data for your community, county and country.
            // Includes tools for data journalists, bloggers and community activists.
            url: 'https://www.justicemap.org/tile/{size}/{variant}/{z}/{x}/{y}.png',
            options: {
                attribution: '<a href="http://www.justicemap.org/terms.php">Justice Map</a>',
                // one of 'county', 'tract', 'block'
                size: 'county',
                // Bounds for USA, including Alaska and Hawaii
                bounds: [[14, -180], [72, -56]]
            },
            variants: {
                income: 'income',
                americanIndian: 'indian',
                asian: 'asian',
                black: 'black',
                hispanic: 'hispanic',
                multi: 'multi',
                nonWhite: 'nonwhite',
                white: 'white',
                plurality: 'plural'
            }
        },
        GeoportailFrance: {
            url: 'https://wxs.ign.fr/{apikey}/geoportail/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE={style}&TILEMATRIXSET=PM&FORMAT={format}&LAYER={variant}&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}',
            options: {
                attribution: '<a target="_blank" href="https://www.geoportail.gouv.fr/">Geoportail France</a>',
                bounds: [[-75, -180], [81, 180]],
                minZoom: 2,
                maxZoom: 18,
                // Get your own geoportail apikey here : http://professionnels.ign.fr/ign/contrats/
                // NB : 'choisirgeoportail' is a demonstration key that comes with no guarantee
                apikey: 'choisirgeoportail',
                format: 'image/png',
                style: 'normal',
                variant: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2'
            },
            variants: {
                plan: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2',
                parcels: {
                    options: {
                        variant: 'CADASTRALPARCELS.PARCELLAIRE_EXPRESS',
                        style: 'PCI vecteur',
                        maxZoom: 20
                    }
                },
                orthos: {
                    options: {
                        maxZoom: 19,
                        format: 'image/jpeg',
                        variant: 'ORTHOIMAGERY.ORTHOPHOTOS'
                    }
                }
            }
        },
        OneMapSG: {
            url: 'https://maps-{s}.onemap.sg/v3/{variant}/{z}/{x}/{y}.png',
            options: {
                variant: 'Default',
                minZoom: 11,
                maxZoom: 18,
                bounds: [[1.56073, 104.11475], [1.16, 103.502]],
                attribution: '<img src="https://docs.onemap.sg/maps/images/oneMap64-01.png" style="height:20px;width:20px;"/> New OneMap | Map data &copy; contributors, <a href="http://SLA.gov.sg">Singapore Land Authority</a>'
            },
            variants: {
                Default: 'Default',
                Night: 'Night',
                Original: 'Original',
                Grey: 'Grey',
                LandLot: 'LandLot'
            }
        },
        USGS: {
            url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}',
            options: {
                maxZoom: 20,
                attribution: 'Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>'
            },
            variants: {
                USTopo: {},
                USImagery: {
                    url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}'
                },
                USImageryTopo: {
                    url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}'
                }
            }
        },
        WaymarkedTrails: {
            url: 'https://tile.waymarkedtrails.org/{variant}/{z}/{x}/{y}.png',
            options: {
                maxZoom: 18,
                attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="https://waymarkedtrails.org">waymarkedtrails.org</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            },
            variants: {
                hiking: 'hiking',
                cycling: 'cycling',
                mtb: 'mtb',
                slopes: 'slopes',
                riding: 'riding',
                skating: 'skating'
            }
        },
        OpenAIP: {
            url: 'https://{s}.tile.maps.openaip.net/geowebcache/service/tms/1.0.0/openaip_basemap@EPSG%3A900913@png/{z}/{x}/{y}.{ext}',
            options: {
                attribution: '<a href="https://www.openaip.net/">openAIP Data</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-NC-SA</a>)',
                ext: 'png',
                minZoom: 4,
                maxZoom: 14,
                tms: true,
                detectRetina: true,
                subdomains: '12'
            }
        },
        OpenSnowMap: {
            url: 'https://tiles.opensnowmap.org/{variant}/{z}/{x}/{y}.png',
            options: {
                minZoom: 9,
                maxZoom: 18,
                attribution: 'Map data: {attribution.OpenStreetMap} & ODbL, &copy; <a href="https://www.opensnowmap.org/iframes/data.html">www.opensnowmap.org</a> <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
            },
            variants: {
                pistes: 'pistes',
            }
        },
        AzureMaps: {
            url:
                'https://atlas.microsoft.com/map/tile?api-version={apiVersion}'+
                '&tilesetId={variant}&x={x}&y={y}&zoom={z}&language={language}'+
                '&subscription-key={subscriptionKey}',
            options: {
                attribution: 'See https://docs.microsoft.com/en-us/rest/api/maps/render-v2/get-map-tile for details.',
                apiVersion: '2.0',
                variant: 'microsoft.imagery',
                subscriptionKey: '<insert your subscription key here>',
                language: 'en-US',
            },
            variants: {
                MicrosoftImagery: 'microsoft.imagery',
                MicrosoftBaseDarkGrey: 'microsoft.base.darkgrey',
                MicrosoftBaseRoad: 'microsoft.base.road',
                MicrosoftBaseHybridRoad: 'microsoft.base.hybrid.road',
                MicrosoftTerraMain: 'microsoft.terra.main',
                MicrosoftWeatherInfraredMain: {
                    url:
                        'https://atlas.microsoft.com/map/tile?api-version={apiVersion}'+
                        '&tilesetId={variant}&x={x}&y={y}&zoom={z}'+
                        '&timeStamp={timeStamp}&language={language}' +
                        '&subscription-key={subscriptionKey}',
                    options: {
                        timeStamp: '2021-05-08T09:03:00Z',
                        attribution: 'See https://docs.microsoft.com/en-us/rest/api/maps/render-v2/get-map-tile#uri-parameters for details.',
                        variant: 'microsoft.weather.infrared.main',
                    },
                },
                MicrosoftWeatherRadarMain: {
                    url:
                        'https://atlas.microsoft.com/map/tile?api-version={apiVersion}'+
                        '&tilesetId={variant}&x={x}&y={y}&zoom={z}'+
                        '&timeStamp={timeStamp}&language={language}' +
                        '&subscription-key={subscriptionKey}',
                    options: {
                        timeStamp: '2021-05-08T09:03:00Z',
                        attribution: 'See https://docs.microsoft.com/en-us/rest/api/maps/render-v2/get-map-tile#uri-parameters for details.',
                        variant: 'microsoft.weather.radar.main',
                    },
                }
            },
        },
        SwissFederalGeoportal: {
            url: 'https://wmts.geo.admin.ch/1.0.0/{variant}/default/current/3857/{z}/{x}/{y}.jpeg',
            options: {
                attribution: '&copy; <a href="https://www.swisstopo.admin.ch/">swisstopo</a>',
                minZoom: 2,
                maxZoom: 18,
                bounds: [[45.398181, 5.140242], [48.230651, 11.47757]]
            },
            variants: {
                NationalMapColor: 'ch.swisstopo.pixelkarte-farbe',
                NationalMapGrey: 'ch.swisstopo.pixelkarte-grau',
                SWISSIMAGE: {
                    options: {
                        variant: 'ch.swisstopo.swissimage',
                        maxZoom: 19
                    }
                }
            }
        }
    };

    L.tileLayer.provider = function (provider, options) {
        return new L.TileLayer.Provider(provider, options);
    };

    return L;
}));
//// ------------------------------------------


export function initMap(lat, lng, mapId, zoom = 7, maxZoom = 25, searchBox = true, direction = true, loadMarker = true) {
    if (window.innerWidth < 768 && zoom === 7) {
        zoom = 6;
    }

    const requestData = {};
    $.each(window.location.search.replace('?', '').split('&'), function(c, q) {
        const i = q.split('=');
        requestData[i[0]] = i[1];
    });

    if (Object.keys(requestData).length > 0 && typeof requestData === 'object') {
        try {
            backData = JSON.parse(decodeURIComponent(localStorage.getItem('backData')));
            localStorage.removeItem('backData');
        } catch (e) {

        }
    }

    let centerPoint = new L.LatLng(lat, lng);

    if (backData?.lat && backData?.lon) {
        centerPoint = new L.LatLng(backData.lat, backData.lon);
    }

    const tiles = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        scrollWheelZoom: false,
        maxZoom: maxZoom,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });


    map = L.map(mapId, {center: centerPoint, zoom: zoom, position: 'topright', layers: [tiles]});
    map.scrollWheelZoom.disable();

    if (searchBox) {
        //const style = (window.innerWidth < 768 || $('.mobile-app').length > 0) ? 'modal' : 'bar';
        const style = 'modal';
        const search = new GeoSearch.GeoSearchControl({
            provider: new GeoSearch.OpenStreetMapProvider({
                params: {
                    'accept-language': 'pl', // render results in Dutch
                    countrycodes: 'pl', // limit search results to the Netherlands
                    addressdetails: 10, // include additional address detail parts
                },
            }),
            style: style,
            showMarker: false,
            zoomLevel: 22,
            retainZoomLevel: true,
            searchLabel: 'Znajdź tron',
        });

        map.addControl(search);

        map.on('geosearch/showlocation', function () {
            $('.leaflet-geosearch-modal').removeClass('show');
            $('.leaflet-control-container').removeClass('search');
            $('#throne-details').removeClass('preview').removeClass('show');
            $('#show-route').removeClass('show');
            $('.map-buttons').removeClass('open');
        });
    }

    map.on('geosearch/showlocation', (result) => {
        setTimeout( function () {
            map.setZoom(14);
        }, 800);
    });

    if (loadMarker) {
        map.whenReady(function () {
            if (!backData?.lat || !backData?.lon) {
                getLocation(showCurrentPositionWithMarker);
            }
        });
        // getLocation(showCurrentPositionWithMarker);

        loadMarkers(direction);
    }

    if (
        (centerPoint.lat >= 16.24588251113892 && centerPoint.lng <= 16.306178569793705) &&
        (centerPoint.lat >= 53.512187652398964 && centerPoint.lng <= 53.52860638860726)
    ) {
        setTimeout(function () {
            map.setZoom(14);
        }, 800);
    }

    /*
    map.on('click', (e) => {
        console.log(e.latlng);
    });
*/

    // L.tileLayer.provider('CartoDB.Positron').addTo(map);
}

const removeRoutingControl = function () {
    if (routingControl != null) {
        map.removeControl(routingControl);
        routingControl = null;
        $('.leaflet-top.leaflet-right').removeClass('show');
        $('#show-route').removeClass('show');
        $('#throne-details').removeClass('preview').removeClass('show');
        $('.map-buttons').removeClass('open');
    }
};

const removePolylines = function () {
    if (polylines != null) {
        polylines.forEach(function (item) {
            map.removeLayer(item)
        });
        polylines = [];
    }
};

const addRoutingControl = function (waypoints, showRoute = true) {
    if (routingControl != null) {
        removeRoutingControl();
    }

    removePolylines();

    const startIcon = L.icon({
        iconUrl: 'current-position.png',
        iconSize:     [21, 25], // size of the icon
        // iconAnchor:   [10, 18], // point of the icon which will correspond to marker's location
    });

    const endIcon = L.icon({
        iconUrl: 'end-icon.png',

        iconSize:     [51, 71], // size of the icon
        iconAnchor:   [25, 72], // point of the icon which will correspond to marker's location
    });

    if (
        (waypoints[0].lng >= 16.24588251113892 && waypoints[0].lng <= 16.306178569793705) &&
        (waypoints[0].lat >= 53.512187652398964 && waypoints[0].lat <= 53.52860638860726) &&
        (waypoints[1].lng >= 16.24588251113892 && waypoints[1].lng <= 16.306178569793705) &&
        (waypoints[1].lat >= 53.512187652398964 && waypoints[1].lat <= 53.52860638860726)
    ) {
        let distance = getDistance(waypoints);

        const oneMeter = 1.666666667;
        let timeDistance =  distance / oneMeter;
        const time = timeDistance.toFixed(0);

        let convertDistance = distance / 1000;

        if (convertDistance < 1) {
            distance = `${distance.toFixed(0)} m`
        } else {
            distance = `${convertDistance.toFixed(1)} km`
        }

        $('#throne-details .throne-details-location .throne-details-location-time').text(formatDuration(time));
        $('#throne-details .throne-details-location .throne-details-location-time').prop('data-time', formatDuration(time));
        $('#throne-details .throne-details-location .throne-details-location-distance').text(distance);
        $('#throne-details .throne-details-location .throne-details-location-distance').prop('data-distance', distance);

        $('#throne-details .throne-details-location').addClass('show');

        $('#show-route').addClass('show');

        if (showRoute === true) {
            let polyline = new L.polyline([[waypoints[0].lat, waypoints[0].lng], [waypoints[1].lat, waypoints[1].lng]]).addTo(map);
            polylines.push(polyline);
        }


    }
    else {
        routingControl = L.Routing.control({
            waypoints: waypoints,
            language: 'pl',
            formatter: new L.Routing.Formatter({
                language: 'pl'
            }),
            serviceUrl: '/throne/routes',
            fitSelectedRoutes: true,
            createMarker: function (i, wp, nWps) {
                if (i === 0) {
                    // here change the starting and ending icons/
                    return L.marker(wp.latLng, {
                        icon: startIcon // here pass the custom marker icon instance
                    });
                } else if (i === nWps - 1) {
                    return L.marker(wp.latLng, {
                        icon: endIcon // here pass the custom marker icon instance
                    }).setZIndexOffset(16100000);
                }
            }
        })
            .on('routesfound', function (e) {
                const summary = e.routes[0].summary;
                let time = summary.totalTime;
                let distance = summary.totalDistance;

                let convertDistance = distance / 1000;

                if (convertDistance < 1) {
                    distance = `${distance} m`
                } else {
                    distance = `${convertDistance.toFixed(1)} km`
                }

                $('#throne-details .throne-details-location .throne-details-location-time').text(formatDuration(time));
                $('#throne-details .throne-details-location .throne-details-location-time').prop('data-time', formatDuration(time));
                $('#throne-details .throne-details-location .throne-details-location-distance').text(distance);
                $('#throne-details .throne-details-location .throne-details-location-distance').prop('data-distance', distance);

                $('#throne-details .throne-details-location').addClass('show');

                $('#show-route').addClass('show');
            })
            .addTo(map);

        if (showRoute === false) {
            try {
                map.removeControl(routingControl);
                routingControl = null;
            } catch (e) {

            }
        }

    }
};


export function showDirection(lat, lng, showRoute = false) {
    let centerLatLng = map.getCenter();

    if (coords.lat && coords.lon) {
        centerLatLng = {
            'lat': coords.lat,
            'lng': coords.lon,
        }
    }
    addRoutingControl([
        L.latLng(centerLatLng.lat, centerLatLng.lng),
        L.latLng(lat, lng),
    ], showRoute);
}

export function addMarker(lat, lng, throneData, direction = true) {
    let m;
    let w;
    let h;

    if (throneData.kind === 'wctron') {
        w = 48;
        h = 48;
    } else {
        w = 24;
        h = 24;
    }

    const icon = L.icon({
        iconUrl: `${throneData.kind}.png`,

        iconSize:     [w, h], // size of the icon
        iconAnchor:   [10, 18], // point of the icon which will correspond to marker's location
    });

    if (throneData.kind === 'wctron') {

        m = new L.Marker([lat, lng], { icon: L.divIcon({
                className: "",
                html: '<div><div style="top: -5px; left: 35px; padding: 2px; font-size: 8px; font-weight: bold; position: absolute; background: #00ff0a; border-radius: 35px;">' + throneData.qty + '</div><img style="width: '+ w +'px; height: '+ h +'px;" src="' + `${throneData.kind}.png` + '" </div>',
                iconSize: L.point(w, h),
            }) });
    } else {
        m = new L.Marker([lat, lng], { icon: icon });
    }

    m.throneData = throneData;
    m.on('click', function (e) {
        throneDetails(e);
        currentMarker = m;
    });

    markersList.push(m);
    markersCoords.push([lat, lng]);
    markers.addLayer(m);
}

const throneDetails = function (e) {
    let throne = e.target.throneData;

    setTimeout(function() {
        if (closestCoords.lat && closestCoords.lon) {
            showDirection(closestCoords.lat, closestCoords.lon, false);
            closestCoords = {lat: "", lon: ""};
        } else {
            showDirection($('#throne-details .throne-details-location').prop('data-lat'), $('#throne-details .throne-details-location').prop('data-lng'), false)
        }
    }, 500);

    localStorage.removeItem('backData');

    $('.leaflet-marker-icon.active').removeClass('active');
    $(e.target._icon).addClass('active');

    if (routingControl != null) {
        removeRoutingControl();
    }

    removePolylines();

    $('#throne-details .throne-details-location').removeClass('show');

    $('#throne-details-logo').prop('src', `${throne.kind}.png`);
    $('#throne-details .throne-details-header .throne-details-header-name').text(throne.name);
    $('#throne-details .throne-details-header .throne-details-header-address').text(throne.address);

    const openPeriodicFrom = new Date(throne.openPeriodicFrom);
    const openPeriodicTo = new Date(throne.openPeriodicTo);
    let openPeriodic = throne.openPeriodicFrom && throne.openPeriodicTo;
    let openPeriodicCurrent = false;
    let opening = 'Zamknięty';

    if (openPeriodic) {
        if (openPeriodicFrom.getTime() <= now.getTime() && openPeriodicTo.getTime() >= now.getTime()) {
            openPeriodicCurrent = true;
        }
    }

    if (!openPeriodic || openPeriodicCurrent) {
        if (Object.keys(throne.openByDays).length > 0) {
            opening = throne.openByDays[now.getDay()] ? `${throne.openByDays[now.getDay()].from} - ${throne.openByDays[now.getDay()].to}` : 'Zamknięty';
        } else {
            opening = '24/7'
        }
    }

    $('#throne-details .throne-details-location').prop('data-lat', throne.lat).prop('data-lng', throne.lng);

    $('#throne-details .throne-details-location .throne-details-location-opening-hours').text(opening);

    $('#throne-details .throne-details-description .throne-details-description-content').text(throne.description);

    let throneImages = '';

    throne.images.forEach(function (image) {
        throneImages += `<img src="${image}" alt="" />`;
    });

    if (throneImages) {
        $('#throne-details .throne-details-images').html(`<div class="throne-details-images-list">${throneImages}</div>`);
    } else {
        $('#throne-details .throne-details-images').html(``);
    }

    throneImages = '';

    let throneParameters = '';

    throne.parameters.forEach(function (parameter) {
        throneParameters += `<div class="d-flex justify-content-start align-items-center gap-3 pb-2">
                                            <img src="${parameter.icon}" alt="" />
                                            <p>${parameter.name}</p>
                                        </div>`;
    });

    $('#throne-details .throne-details-parameters-list').html(throneParameters);

    throneParameters = '';

    $('#throne-opinion-form').prop('action', throne.opinionUrl);

    $('#throne-wrong-information-form').prop('action', `/throne/issue/${throne.id}`);
    $('#throne-issue-form').prop('action', `/throne/issue/${throne.id}`);

    let opinions = '';
    let totalRating = 0;

    if (throne.isUserOpinion) {
        $('#throne-details-opinions-button').addClass('d-none');
    } else {
        $('#throne-details-opinions-button').removeClass('d-none');
    }

    throne.opinions.forEach(function (opinion, index) {
        let stars = '';
        totalRating += opinion.rating;

        for (let i = 0; i < 5; i++) {
            stars += `<i class="bi bi-star${opinion.rating >= (i + 1) ? '-fill' : ''}"></i>`;
        }

        opinions += `
                <div class="throne-details-opinion ${index < 3 ? 'show' : ''}" data-opinion="${opinion.id}">
                    <div class="d-flex justify-content-between align-items-center">
                        <h3>${opinion.firstname}</h3>
                        <span>${opinion.createTime} | ${opinion.createDate}</span>
                    </div>
                    <p>${opinion.content}</p>
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="stars d-flex justify-content-start align-items-center">
                            ${stars}
                        </div>
                        
                        <div class="d-flex">
                            <div class="voting-yes voting ${opinion.vote && opinion.vote === 'yes' ? 'active' : ''}">
                                <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.625 4.0075C13.4842 3.84795 13.3111 3.72019 13.1171 3.63269C12.9231 3.54519 12.7128 3.49996 12.5 3.5H9V2.5C9 1.83696 8.73661 1.20107 8.26777 0.732233C7.79893 0.263392 7.16304 1.28189e-07 6.5 1.28189e-07C6.40711 -6.63752e-05 6.31604 0.0257445 6.237 0.0745385C6.15795 0.123333 6.09407 0.19318 6.0525 0.27625L3.69125 5H1C0.734784 5 0.48043 5.10536 0.292893 5.29289C0.105357 5.48043 0 5.73478 0 6V11.5C0 11.7652 0.105357 12.0196 0.292893 12.2071C0.48043 12.3946 0.734784 12.5 1 12.5H11.75C12.1154 12.5001 12.4684 12.3668 12.7425 12.1252C13.0166 11.8835 13.1931 11.5501 13.2388 11.1875L13.9888 5.1875C14.0153 4.97626 13.9966 4.76179 13.9339 4.55833C13.8712 4.35488 13.7659 4.16711 13.625 4.0075ZM1 6H3.5V11.5H1V6ZM12.9963 5.0625L12.2463 11.0625C12.231 11.1834 12.1722 11.2945 12.0808 11.3751C11.9895 11.4556 11.8718 11.5 11.75 11.5H4.5V5.61812L6.79437 1.02875C7.13443 1.09681 7.4404 1.2806 7.66021 1.54884C7.88002 1.81708 8.0001 2.1532 8 2.5V4C8 4.13261 8.05268 4.25979 8.14645 4.35355C8.24021 4.44732 8.36739 4.5 8.5 4.5H12.5C12.571 4.49998 12.6411 4.51505 12.7058 4.54423C12.7704 4.5734 12.8282 4.61601 12.8751 4.66922C12.9221 4.72242 12.9571 4.78501 12.978 4.85282C12.9989 4.92063 13.0051 4.9921 12.9963 5.0625Z" fill="#1A43B4"/>
                                </svg>

                                <span class="vote-count">${opinion.yes || 0}</span>
                            </div>
                            <div class="voting-no voting ${opinion.vote && opinion.vote === 'no' ? 'active' : ''}">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.9888 9.8125L14.2388 3.8125C14.1931 3.44993 14.0166 3.1165 13.7425 2.87483C13.4684 2.63316 13.1154 2.49987 12.75 2.5H2C1.73478 2.5 1.48043 2.60536 1.29289 2.79289C1.10536 2.98043 1 3.23478 1 3.5V9C1 9.26522 1.10536 9.51957 1.29289 9.70711C1.48043 9.89464 1.73478 10 2 10H4.69125L7.0525 14.7238C7.09407 14.8068 7.15795 14.8767 7.237 14.9255C7.31604 14.9743 7.40711 15.0001 7.5 15C8.16304 15 8.79893 14.7366 9.26777 14.2678C9.73661 13.7989 10 13.163 10 12.5V11.5H13.5C13.7129 11.5001 13.9233 11.4548 14.1173 11.3673C14.3113 11.2798 14.4845 11.152 14.6253 10.9923C14.7662 10.8327 14.8714 10.645 14.9341 10.4415C14.9967 10.2381 15.0154 10.0237 14.9888 9.8125ZM4.5 9H2V3.5H4.5V9ZM13.875 10.3306C13.8284 10.3842 13.7708 10.4271 13.706 10.4564C13.6413 10.4856 13.571 10.5005 13.5 10.5H9.5C9.36739 10.5 9.24021 10.5527 9.14645 10.6464C9.05268 10.7402 9 10.8674 9 11V12.5C9.0001 12.8468 8.88002 13.1829 8.66021 13.4512C8.4404 13.7194 8.13443 13.9032 7.79437 13.9712L5.5 9.38188V3.5H12.75C12.8718 3.49996 12.9895 3.54439 13.0808 3.62494C13.1722 3.7055 13.231 3.81664 13.2463 3.9375L13.9963 9.9375C14.0056 10.0079 13.9996 10.0795 13.9787 10.1473C13.9578 10.2152 13.9224 10.2777 13.875 10.3306Z" fill="#1A43B4"/>
                                </svg>

                                <span class="vote-count">${opinion.no || 0}</span>
                            </div>
                        </div>
                    </div>
                    <hr/>
                </div>
            `;
    });

    const ratingValue = (totalRating / throne.opinions.length).toFixed(1) !== 'NaN' ? (totalRating / throne.opinions.length).toFixed(1) : 'brak';
    $('#throne-details .throne-details-header .throne-details-rating-number').text(ratingValue);
    $('#throne-details .throne-details-opinions-title .total-rating').text(ratingValue);

    let opinionsText = 'ocen';

    if (throne.opinions.length === 1) {
        opinionsText = 'ocena';
    } else if (throne.opinions.length > 1 && throne.opinions.length < 5) {
        opinionsText = 'oceny';
    }

    $('#throne-details .throne-details-opinions-title .opinions-count').text(`${throne.opinions.length} ${opinionsText}`);

    if (throne.opinions.length > 3) {
        opinions += `<span class="more-throne-opinions text-primary pt-3">Pokaż wszystkie</span>`;
    }

    $('#throne-details .throne-details-opinions-list').html(opinions);

    opinions = '';

    $('.take-over-throne-info').remove();
    $('.take-over-throne-button').remove();
    $('#take-over-throne-modal').find('form').prop('action', '');

    if (throne.type === 'owner' && throne.state === 'accepted') {
        $('#take-over-throne-modal .throne-details-logo').prop('src', ``);
        $('#take-over-throne-modal .throne-details-header .throne-details-header-name').text('');
        $('#take-over-throne-modal .throne-details-header .throne-details-header-address').text('');
        $('.throne-issue-button').removeClass('d-none');
        $('.throne-details-owner').removeClass('d-none');
        $('.throne-details-owner-information').removeClass('d-none').find('.throne-details-owner').text(throne.owner);
    } else {
        $('.throne-details-owner-information').addClass('d-none').find('.throne-details-owner').text('');
        if (throne.state === 'accepted') {
            $('#take-over-throne-modal .throne-details-logo').prop('src', `${throne.kind}.png`);
            $('#take-over-throne-modal .throne-details-header .throne-details-header-name').text(throne.name);
            $('#take-over-throne-modal .throne-details-header .throne-details-header-address').text(throne.address);
            $('.throne-issue-button').addClass('d-none');
            $('.throne-details-owner').addClass('d-none');
            $('.throne-details-bottom-container').append('<p class="take-over-throne-info">Ten tron nie ma właściciela.</p>');
            $('.throne-details-bottom-container').append('<p class="take-over-throne-info">Jesteś właścicielem tego tronu?</p>');
            $('.throne-details-bottom-container').append(`<button class="btn btn-dark btn-md wide take-over-throne-button text-white my-2">Przejmij tron</button>`);
            $('#take-over-throne-modal').find('form').prop('action', `/throne/take-over/${throne.id}`);
        }
    }


    if (throne.owner) {
        if(throne.type == 'user') {
            $('.throne-details-owner-information').removeClass('d-none').find('.throne-details-owner').html('Tron został dodany przez: <strong>' + throne.owner + '</strong>');
        } else {
            $('.throne-details-owner-information').removeClass('d-none').find('.throne-details-owner').html('Tron należy do: <strong>' + throne.owner + '</strong>');
        }
    } else {
        $('.throne-details-owner-information').addClass('d-none').find('.throne-details-owner').html('');
    }

    $('#throne-details').addClass('preview');
    $('.map-buttons').addClass('open');

    // if ($('.login-button').length > 0) {
        // $('.login-button').each(function () {
        //     const throneBackData = JSON.stringify({
        //         lat: throne.lat,
        //         lon: throne.lng,
        //         action: $(this).attr('data-action'),
        //     });
        //     $(this).prop('href', `${$(this).prop('href')}/?_target_path=/?backData=${throneBackData}`)
        // });
    // }

    throne = null;
}

$('#throne-details').on('click', '.take-over-throne-button', function () {
    $('#take-over-throne-modal').modal('show');
});

$('.login-button').on('click', function (e) {
    e.preventDefault();

    localStorage.setItem('backData', JSON.stringify({
        lat: $('#throne-details .throne-details-location').prop('data-lat'),
        lon: $('#throne-details .throne-details-location').prop('data-lng'),
        action: $(this).attr('data-action'),
    }));

    window.location.href = $(this).attr('href');
});

$('.route-to-throne-button').on('click', function () {
    if (closestCoords.lat && closestCoords.lon) {
        showDirection(closestCoords.lat, closestCoords.lon, true);
        closestCoords = {lat: "", lon: ""};
    } else {
        showDirection($('#throne-details .throne-details-location').prop('data-lat'), $('#throne-details .throne-details-location').prop('data-lng'), true)
    }
});

export function reloadMarkers(opinionId) {
    try {
        $.ajax({
            url: '/throne-by-opinion-id/' + opinionId,
            dataType: 'json',
            type: 'GET',
            success: function (response) {
                for (var throne of response) {
                    for (let i = 0; i < markersList.length; i++) {
                        if (markersList[i].throneData.id === throne.id) {
                            markersList[i].throneData.opinions = throne.opinions;
                        }
                    }
                }
                map.addLayer(markers);
            }
        });

    } catch (xhr) {
        $('.mobile-loader').removeClass('show');
    }
}

export function loadMarkers(direction = true) {
    try {
        $.ajax({
            url: '/throne/list',
            dataType: 'json',
            type: 'GET',
            success: function (response) {
                markersCoords = [];
                for (var throne of response) {
                    addMarker(parseFloat(throne.lat), parseFloat(throne.lng), throne, direction);
                }
                map.addLayer(markers);

                if (backData?.lat && backData?.lon) {
                    map.setZoom(15);

                    setTimeout(function () {
                        const backMarker = GeometryUtil.closestLayer(map, markersList, [backData.lat, backData.lon]).layer;

                        try {
                            markers.getVisibleParent(backMarker).spiderfy();
                        } catch (e) {

                        }

                        backMarker.fire('click');

                        if (backData?.action) {
                            switch (backData.action) {
                                case 'opinion':
                                    $('#throne-opinion-modal').modal('show');
                                    break;
                                case 'wrong-information':
                                    $('#throne-wrong-information-modal').modal('show');
                                    break;
                                case 'issue':
                                    $('#throne-issue-modal').modal('show');
                                    break;
                                default:
                                    break;
                            }
                        }
                    }, 600);
                }
            }
        });
    } catch (xhr) {
        $('.mobile-loader').removeClass('show');
    }
}

$('#close-throne-details-map').on('click', function (e) {
    e.preventDefault();
    $('#throne-details').removeClass('preview').removeClass('show');
    $('.map-buttons').removeClass('open');
    $('.leaflet-marker-icon.active').removeClass('active');

    localStorage.removeItem('backData');

    if (routingControl != null) {
        removeRoutingControl();
    }

    removePolylines();
});

$('#more-throne-details').on('click', function () {
    if (!$('#throne-details').hasClass('show')) {
        $('#throne-details').addClass('show');
    } else {
        $('#throne-details').removeClass('show');
    }
});

$('#filter-thrones-form').on('submit-success', function (e, data) {
    if (routingControl != null) {
        removeRoutingControl();
    }

    removePolylines();

    $('#throne-details').removeClass('preview').removeClass('show');
    $('.map-buttons').removeClass('open');
    markers.clearLayers();
    markersCoords = [];
    for (var throne of data.thrones) {
        addMarker(parseFloat(throne.lat), parseFloat(throne.lng), throne, true);
    }
    map.addLayer(markers);
    setTimeout(function () {
        map.setZoom(6);
        // map.locate({setView: true, maxZoom: 6});
    }, 800);
    $("#throne-filters-modal").modal('hide');
});

$('#throne-details-opinions-button').on('click', function () {
    $('#throne-opinion-modal').modal('show');
});

$('.throne-wrong-information-button').on('click', function (e) {
    e.preventDefault();

    $('#throne-wrong-information-modal').modal('show');
})

$('.throne-issue-button').on('click', function (e) {
    e.preventDefault();

    $('#throne-issue-modal').modal('show');
})

$('#throne-opinion-modal').on('hide.bs.modal', function () {
    $('#throne-opinion-form').removeClass('d-none');
    $('#throne-opinion-modal').find('h2').text('Dodaj opinię');
    $('#add-opinion-button').removeClass('d-none');
    $('#close-opinion-modal-button').addClass('d-none');
    $('#throne-opinion-modal .stars .star').removeClass('bi-star-fill').removeClass('active').addClass('bi-star');
    $('.counter').text('0');
});

$('#throne-wrong-information-modal').on('hide.bs.modal', function () {
    $('#throne-wrong-information-form').removeClass('d-none');
    $('#throne-wrong-information-modal').find('h2').text('Błędne informacje');
    $('#add-wrong-information-button').removeClass('d-none');
    $('#close-wrong-information-modal-button').addClass('d-none');
    $('.throne-wrong-information-thanks').addClass('d-none');
    $('.counter').text('0');
});

$('#throne-issue-modal').on('hide.bs.modal', function () {
    $('#throne-issue-form').removeClass('d-none');
    $('#throne-issue-modal').find('h2').text('Zgłoś problem');
    $('#add-issue-button').removeClass('d-none');
    $('#close-issue-modal-button').addClass('d-none');
    $('.throne-issue-thanks').addClass('d-none');
    $('.counter').text('0');
});

$('#take-over-throne-modal').on('hide.bs.modal', function () {
    $('#throne-take-over-form').removeClass('d-none');
    $('#take-over-throne-modal').find('h2').text('Przejmij tron');
    $('#take-over-button').removeClass('d-none');
    $('#close-throne-take-over-modal-button').addClass('d-none');
    $('.throne-take-over-thanks').addClass('d-none');
    $('#take-over-throne-modal .take-over-throne-info-text').removeClass('d-none');
    $('#take-over-throne-modal .throne-details-header').removeClass('d-none');
    $('#take-over-throne-modal .add-another-throne').addClass('d-none');
});

$('#throne-opinion-modal .stars .star').on('click', function () {
    const index = $(this).index();

    $('#throne-opinion-modal .stars .star').removeClass('bi-star-fill').removeClass('active').addClass('bi-star');

    $('#throne-opinion-modal #throne-rating-value').val(index + 1);

    for (let i = index; i >= 0; i--) {
        $($('#throne-opinion-modal .stars .star')[i]).addClass('active').removeClass('bi-star').addClass('bi-star-fill');
    }
});

$('#throne-opinion-modal .stars .star').on('mouseover', function () {
    const index = $(this).index();

    for (let i = index; i >= 0; i--) {
        $($('#throne-opinion-modal .stars .star')[i]).addClass('hover').removeClass('bi-star').addClass('bi-star-fill');
    }
});

$('#throne-opinion-modal .stars .star').on('mouseleave', function () {
    $('#throne-opinion-modal .stars .star').removeClass('hover');
    $('#throne-opinion-modal .stars .star:not(.active)').removeClass('hover').addClass('bi-star').removeClass('bi-star-fill');
});

$('#throne-details .throne-details-opinions-list').on('click', '.more-throne-opinions', function () {
    $(this).addClass('d-none');
    $('#throne-details .throne-details-opinions-list').find('.throne-details-opinion:not(.show)').addClass('show');
});

$('#throne-details .throne-details-opinions-list').on('click', '.voting:not(.disabled)', function () {
    const token = $('#throne-details .throne-details-opinions-list').attr('data-token');
    const opinionId = $(this).closest('.throne-details-opinion').attr('data-opinion');
    let formData = new FormData();
    const type = $(this).hasClass('voting-yes') ? 'yes' : 'no';
    const opinionContainer = $(this).closest('.throne-details-opinion');
    const self = this;

    $('#throne-details .throne-details-opinions-list').find('.voting').addClass('disabled');

    formData.set('_token', token);
    formData.set('type', type);
    const url = `/throne/opinion/vote/${opinionId}`;

    try {
        $.ajax({
            url: url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            complete: function (response) {
                const data = response.responseJSON;

                $('#throne-details .throne-details-opinions-list').find('.voting').removeClass('disabled');

                if (data.status === 'error') {
                    alert("Wystąpił nieznany błąd, spróbuj ponownie później.");
                } else {
                    opinionContainer.find('.voting').removeClass('active');
                    if (!data.removedVote) {
                        $(self).addClass('active');
                    }
                    opinionContainer.find('.voting-yes .vote-count').text(data.yes);
                    opinionContainer.find('.voting-no .vote-count').text(data.no);
                    reloadMarkers(opinionId);
                }
            }
        });
    } catch (xhr) {
        $('#throne-details .throne-details-opinions-list').find('voting').removeClass('disabled');
    }
});

$('#show-route').on('click', function () {
    $('.leaflet-control-container .leaflet-top.leaflet-right').find('h2').html('<span>Jak najszybciej dotrzeć do Twojego TRONU?</span><i class="bi bi-x-circle icon-close close-route"></i>');

    $('.leaflet-control-container .leaflet-top.leaflet-right').find('h3').html(`
        <div class="d-flex justify-content-around align-items-center route-details">
            <div class="d-flex justify-content-start align-items-center gap-2">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.5 13.5001C6.5 13.6327 6.44732 13.7599 6.35355 13.8537C6.25979 13.9474 6.13261 14.0001 6 14.0001H3C2.86739 14.0001 2.74021 13.9474 2.64645 13.8537C2.55268 13.7599 2.5 13.6327 2.5 13.5001C2.5 13.3675 2.55268 13.2403 2.64645 13.1466C2.74021 13.0528 2.86739 13.0001 3 13.0001H6C6.13261 13.0001 6.25979 13.0528 6.35355 13.1466C6.44732 13.2403 6.5 13.3675 6.5 13.5001ZM4.5 11.5001C4.5 11.3675 4.44732 11.2403 4.35355 11.1466C4.25979 11.0528 4.13261 11.0001 4 11.0001H2C1.86739 11.0001 1.74021 11.0528 1.64645 11.1466C1.55268 11.2403 1.5 11.3675 1.5 11.5001C1.5 11.6327 1.55268 11.7599 1.64645 11.8537C1.74021 11.9474 1.86739 12.0001 2 12.0001H4C4.13261 12.0001 4.25979 11.9474 4.35355 11.8537C4.44732 11.7599 4.5 11.6327 4.5 11.5001ZM16 12.5001V13.0001C16 13.2653 15.8946 13.5197 15.7071 13.7072C15.5196 13.8948 15.2652 14.0001 15 14.0001H9.20687C8.94323 14.0006 8.69014 13.8966 8.50313 13.7107L1.79875 7.21387L1.79313 7.20825C1.60573 7.02073 1.50046 6.76648 1.50046 6.50137C1.50046 6.23627 1.60573 5.98202 1.79313 5.7945L5.79313 1.787L5.8025 1.77825C5.9908 1.59685 6.24296 1.49691 6.5044 1.50007C6.76584 1.50323 7.01552 1.60923 7.19938 1.79512L7.7125 2.31262C7.88804 2.48841 7.99186 2.72324 8.00375 2.97137C8.07437 4.40137 9.06625 5.36575 10.5856 5.48825C10.8345 5.50964 11.0665 5.62344 11.2357 5.80724C11.4049 5.99104 11.4992 6.23153 11.5 6.48137V8.00012C11.5 8.53056 11.7107 9.03926 12.0858 9.41434C12.4609 9.78941 12.9696 10.0001 13.5 10.0001C14.163 10.0001 14.7989 10.2635 15.2678 10.7324C15.7366 11.2012 16 11.8371 16 12.5001ZM15 12.5001C15 12.1023 14.842 11.7208 14.5607 11.4395C14.2794 11.1582 13.8978 11.0001 13.5 11.0001C12.9108 11.0008 12.3347 10.8268 11.8444 10.5001H10C9.86739 10.5001 9.74021 10.4474 9.64645 10.3537C9.55268 10.2599 9.5 10.1327 9.5 10.0001C9.5 9.86752 9.55268 9.74034 9.64645 9.64657C9.74021 9.5528 9.86739 9.50012 10 9.50012H10.9038C10.7243 9.19117 10.6019 8.85243 10.5425 8.50012H9.5C9.36739 8.50012 9.24021 8.44745 9.14645 8.35368C9.05268 8.25991 9 8.13273 9 8.00012C9 7.86752 9.05268 7.74034 9.14645 7.64657C9.24021 7.5528 9.36739 7.50012 9.5 7.50012H10.5V6.48137C9.53563 6.40262 8.695 6.04387 8.07 5.44387C7.42062 4.81887 7.0525 3.98075 7.0075 3.017L6.49188 2.50012L2.5 6.50012L9.20125 12.9939L9.20687 12.9989H15V12.5001Z" fill="white"/>
                </svg>
                <div>${$('#throne-details .throne-details-location .throne-details-location-time').prop('data-time')}</div>
            </div>
            <div class="d-flex justify-content-start align-items-center gap-2">
                <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 2C4.81331 2 3.65328 2.35189 2.66658 3.01118C1.67989 3.67047 0.910851 4.60754 0.456726 5.7039C0.00259972 6.80026 -0.11622 8.00666 0.115291 9.17054C0.346802 10.3344 0.918247 11.4035 1.75736 12.2426C2.59648 13.0818 3.66558 13.6532 4.82946 13.8847C5.99335 14.1162 7.19975 13.9974 8.2961 13.5433C9.39246 13.0892 10.3295 12.3201 10.9888 11.3334C11.6481 10.3467 12 9.18669 12 8C11.9982 6.40926 11.3655 4.88419 10.2406 3.75937C9.11581 2.63455 7.59074 2.00182 6 2ZM6 13C5.0111 13 4.0444 12.7068 3.22215 12.1573C2.39991 11.6079 1.75904 10.827 1.38061 9.91342C1.00217 8.99979 0.90315 7.99445 1.09608 7.02455C1.289 6.05464 1.76521 5.16373 2.46447 4.46447C3.16373 3.7652 4.05465 3.289 5.02455 3.09607C5.99446 2.90315 6.99979 3.00216 7.91342 3.3806C8.82705 3.75904 9.60794 4.3999 10.1574 5.22215C10.7068 6.0444 11 7.01109 11 8C10.9985 9.32563 10.4713 10.5965 9.53389 11.5339C8.59653 12.4713 7.32563 12.9985 6 13ZM8.85375 5.14625C8.90024 5.19269 8.93712 5.24783 8.96228 5.30853C8.98744 5.36923 9.0004 5.43429 9.0004 5.5C9.0004 5.56571 8.98744 5.63077 8.96228 5.69147C8.93712 5.75217 8.90024 5.80731 8.85375 5.85375L6.35375 8.35375C6.3073 8.40021 6.25215 8.43706 6.19145 8.4622C6.13075 8.48734 6.0657 8.50028 6 8.50028C5.93431 8.50028 5.86925 8.48734 5.80855 8.4622C5.74786 8.43706 5.69271 8.40021 5.64625 8.35375C5.5998 8.3073 5.56295 8.25215 5.53781 8.19145C5.51266 8.13075 5.49972 8.0657 5.49972 8C5.49972 7.9343 5.51266 7.86925 5.53781 7.80855C5.56295 7.74786 5.5998 7.69271 5.64625 7.64625L8.14625 5.14625C8.19269 5.09976 8.24783 5.06288 8.30853 5.03772C8.36923 5.01256 8.43429 4.99961 8.5 4.99961C8.56571 4.99961 8.63077 5.01256 8.69147 5.03772C8.75217 5.06288 8.80732 5.09976 8.85375 5.14625ZM4 0.5C4 0.367392 4.05268 0.240215 4.14645 0.146447C4.24022 0.0526784 4.36739 0 4.5 0H7.5C7.63261 0 7.75979 0.0526784 7.85356 0.146447C7.94732 0.240215 8 0.367392 8 0.5C8 0.632608 7.94732 0.759785 7.85356 0.853554C7.75979 0.947322 7.63261 1 7.5 1H4.5C4.36739 1 4.24022 0.947322 4.14645 0.853554C4.05268 0.759785 4 0.632608 4 0.5Z" fill="white"/>
                </svg>
                <div>${$('#throne-details .throne-details-location .throne-details-location-distance').prop('data-distance')}</div>
            </div>
        </div>
    `);

    $('.leaflet-control-container .leaflet-top.leaflet-right').addClass('show');
});

$('body').on('click', '.close-route', function () {
    $('.leaflet-control-container .leaflet-top.leaflet-right').removeClass('show');
});

const formatDuration = totalSeconds => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = ((totalSeconds % 3600) / 60) < 10 ? Math.floor((totalSeconds % 3600) / 60) : Math.ceil((totalSeconds % 3600) / 60);
    const seconds = Math.ceil(totalSeconds - hours * 3600 - minutes * 60);

    if (hours === 0 && ((totalSeconds % 3600) / 60) < 10) {
        return [`${minutes} min`, `${seconds} sek`]
            .filter(item => item[0] !== '0')
            .join(' ');
    }

    return [`${hours} h`, `${minutes} min`]
        .filter(item => item[0] !== '0')
        .join(' ');
}

$('.reset-throne-filters').on('click', function () {
    $('#throne-filters-modal').find('.switcher label.checked').each(function () {
        $(this).removeClass('checked');
        $(this).closest('.switcher').find('input').prop('checked', false)

        $('#filter-thrones-form').trigger('submit');
    });
});

window.addEventListener('DOMContentLoaded', (event) => {
    if ($('#maps').length > 0) {
        handlePermission();
        getLocation(showPosition);

        $('.map-content, #navigation').on('click', function () {
            if (window.innerWidth < 768) {
                $('#throne-details').removeClass('show');
            }
        });

        $('#nearest-throne').on('click', function () {
            if (coords.lat && coords.lon) {
                closestCoords = {
                    'lat': GeometryUtil.closestLayer(map, markersList, Object.values(coords)).latlng.lat,
                    'lon': GeometryUtil.closestLayer(map, markersList, Object.values(coords)).latlng.lng,
                };

                map.locate({
                    setView: true,
                    center: new L.LatLng(GeometryUtil.closestLayer(map, markersList, Object.values(coords)).latlng.lat, GeometryUtil.closestLayer(map, markersList, Object.values(coords)).latlng.lng),
                    maxZoom: 15,
                });
                map.setZoom(15);

                setTimeout(function () {
                    try {
                        markers.getVisibleParent(GeometryUtil.closestLayer(map, markersList, Object.values(coords)).layer).spiderfy();
                    } catch (e) {

                    }
                    GeometryUtil.closestLayer(map, markersList, Object.values(coords)).layer.fire('click');
                }, 600);
            }
        });

        $('#find-throne').on('click', function () {
            if ($('.leaflet-geosearch-modal').find('h2').length === 0) {
                $('.leaflet-geosearch-modal').prepend('<h2><span>Znajdź tron</span> <i class="bi bi-x-circle close-throne-search"></i></h2>')
            }

            $('.leaflet-control-container').addClass('search');
            $('.leaflet-geosearch-modal').addClass('show');
        });

        $('#maps').on('click', '.close-throne-search', function () {
            $('.leaflet-control-container').removeClass('search');
            $('.leaflet-geosearch-modal').removeClass('show');
        });
    }
});

function getLocation(callback) {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            coords.lat = position.coords.latitude;
            coords.lon = position.coords.longitude;

            //coords.lat = 53.52033402899353;
            //coords.lon = 16.303968429565433;

            callback();
        }, showError);
    } else {
        coords = {lat: "", lon: ""};
        console.log('Przeglądarka nie wspiera lokalizacji');
    }
}

function showPosition() {
    // console.log(coords);
    $('#nearest-throne').prop('disabled', false);
}

function showCurrentPositionWithMarker() {
    const startIcon = L.icon({
        iconUrl: 'current-position.png',

        iconSize:     [21, 25], // size of the icon
        // iconAnchor:   [10, 18], // point of the icon which will correspond to marker's location
    });

    const marker = new L.Marker([coords.lat, coords.lon], { icon: startIcon }).setZIndexOffset();

    map.addLayer(marker);

    currentPosition.lat = coords.lat;
    currentPosition.lng = coords.lon;

    setTimeout(function () {
        map.locate({
            setView: true,
            center: new L.LatLng(coords.lat, coords.lon),
            maxZoom: 12
        });
        map.setZoom(13);
    }, 200);

    setTimeout(function () {
        map.setZoom(12);
    }, 300);
}

function showNearestThrones() {
    // console.log(coords);
    // initMap(coords.lat, coords.lon, 'maps', 5, 25, false, false, false);
}

function showError(error) {
    switch(error.code) {
        case error.PERMISSION_DENIED:
            console.log("User denied the request for Geolocation.")
            $('#nearest-throne').prop('disabled', true);
            break;
        case error.POSITION_UNAVAILABLE:
            console.log("Location information is unavailable.")
            $('#nearest-throne').prop('disabled', true);
            break;
        case error.TIMEOUT:
            console.log("The request to get user location timed out.")
            $('#nearest-throne').prop('disabled', true);
            break;
        case error.UNKNOWN_ERROR:
            console.log("An unknown error occurred.")
            $('#nearest-throne').prop('disabled', true);
            break;
    }
}

function handlePermission() {
    try {
        navigator.permissions.query({name: "geolocation"}).then((result) => {
            if (result.state === "granted") {
                report(result.state, '1');
                $('#nearest-throne').prop('disabled', false);
            } else if (result.state === "prompt") {
                report(result.state, '2');
            } else if (result.state === "denied") {
                report(result.state, '3');
                $('#nearest-throne').prop('disabled', true);
            }
            result.addEventListener("change", () => {
                report(result.state);
            });
        });
    } catch (e) {

    }
}

function report(state) {
    console.log(`Permission ${state}`);
}

function getDistance(waypoints) {

    let lon1 = toRadian(waypoints[1].lng),
        lat1 = toRadian(waypoints[1].lat),
        lon2 = toRadian(waypoints[0].lng),
        lat2 = toRadian(waypoints[0].lat);

    let deltaLat = lat2 - lat1;
    let deltaLon = lon2 - lon1;

    let a = Math.pow(Math.sin(deltaLat/2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(deltaLon/2), 2);
    let c = 2 * Math.asin(Math.sqrt(a));
    let EARTH_RADIUS = 6371;
    return c * EARTH_RADIUS * 1000;
}
function toRadian(degree) {
    return degree*Math.PI/180;
}
